export default {
    name: 'tabs',
    _toggles: null,
    _targets: null,
    init() {
        this._toggles = document.querySelectorAll('.tab-btn');

        if (!this._toggles) {
            return;
        }

        for (const toggle of this._toggles) {
            toggle.addEventListener('click', (event) => {
                const button = event.target;

                // hide all tabs
                const contents = document.querySelectorAll('.tab-content, .tab-btn');
                contents.forEach((item) => item.classList.remove('active'));


                // set active tab
                button.classList.add('active');
                const activeTab = button.dataset.body;
                document.getElementById(activeTab).classList.add('active');
            });
        }
    }
}